<section id="footer" class="footer-section pt-100 pb-70">
    <div class="container">
        <!-- <div class="subscribe-area">
            <div class="row align-items-center">
                <div class="col-lg-5 col-md-12">
                    <div class="subscribe-content">
                        <h2>Join Our Newsletter</h2>
                    </div>
                </div>
                <div class="col-lg-7 col-md-12">
                    <form class="newsletter-form">
                        <input type="email" class="input-newsletter" placeholder="Enter your email" name="EMAIL">
                        <button type="submit">Subscribe Now</button>
                    </form>
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="footer-heading">
                        <h3>About Me</h3>
                    </div>
                    <p class="footer-description">
                        I’m a passionate Full Stack Developer who loves turning complex problems into clean, scalable solutions. With experience in both front-end and back-end technologies, I bridge the gap between user experience and robust architecture.
                        From building intuitive UIs in Angular and React to designing resilient APIs and data flows, I bring both creativity and logic to every project. I believe great development is not just about writing code — it’s about creating digital experiences that feel effortless.
                        I’m currently open to new opportunities, collaborations, or freelance projects. Let’s build something amazing together. </p>
                    <p>Please give me a call</p>
                    <!-- <ul class="footer-social">
                        <li><a href="https://www.youtube.com/@ElevateTechProductions" target="_blank"><i class="flaticon-play"></i></a></li>
                        <li><a href="https://www.facebook.com/profile.php?id=61558849838554" target="_blank"><i class="flaticon-facebook"></i></a></li>
                        <li><a href="https://www.instagram.com/elevatetecai" target="_blank"><i class="flaticon-instagram"></i></a></li>
                    </ul> -->
                </div>
            </div>
            <!-- <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="footer-heading">
                        <h3>Important Links</h3>
                    </div>
                    <ul class="footer-quick-links">
                        <li><a routerLink="/home-two">About Us</a></li>
                        <li><a routerLink="/home-two">Project</a></li>
                        <li><a routerLink="/home-two">Services</a></li>
                        <li><a routerLink="/home-two">Blog</a></li>
                        <li><a routerLink="/home-two">Contact</a></li>
                    </ul>
                </div>
            </div> -->
            <!-- <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="footer-heading">
                        <h3>Featured Service</h3>
                    </div>
                    <ul class="footer-quick-links">
                        <li><a routerLink="/home-two">IT Management</a></li>
                        <li><a routerLink="/home-two">Development</a></li>
                        <li><a routerLink="/home-two">Services</a></li>
                        <li><a routerLink="/home-two">UI/UX Design</a></li>
                        <li><a routerLink="/home-two">Support Engineer</a></li>
                    </ul>
                </div>
            </div> -->

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="footer-heading">
                        <h3>Contact</h3>
                    </div>
                    <div class="footer-info-contact">
                        <div class="contact-icon-wrapper">
                            <i class="flaticon-phone-call contact-icon" 
                               (click)="makePhoneCall('305-322-0070')"
                               title="Call"></i>
                        </div>
                        <div class="contact-info-content">
                            <h4>Phone</h4>
                            <span class="contact-text" 
                                  (click)="copyToClipboard('305-322-0070', 'Phone')"
                                  title="Click to copy">
                                305-322-0070
                            </span>
                        </div>
                    </div>
                    <div class="footer-info-contact">
                        <div class="contact-icon-wrapper">
                            <i class="flaticon-envelope contact-icon" 
                               (click)="sendEmail('elevatetechagency@gmail.com')"
                               title="Send email"></i>
                        </div>
                        <div class="contact-info-content">
                            <h4>Email</h4>
                            <span class="contact-text" 
                                  (click)="copyToClipboard('elevatetechagency@gmail.com', 'Email')"
                                  title="Click to copy">
                                  cesarvega.col&#64;gmail.com
                            </span>
                        </div>
                    </div>
                    <div class="footer-info-contact">
                        <i class="flaticon-pin"></i>
                        <h3>Address</h3>
                        <span>Based in Miami, FL</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="copyright-area">
    <div class="container">
        <div class="copyright-area-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <p>© Copyright © 2025</p>
                </div>
                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/home-two">Terms & Conditions</a></li>
                        <li><a routerLink="/home-two">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="go-top"><i class="bx bx-chevron-up"></i><i class="bx bx-chevron-up"></i></div>

<div class="sidebar-modal">
    <div class="sidebar-modal-inner">
        <div class="sidebar-about-area">
            <div class="title">
                <h2>About Us</h2>
                <p>We believe brand interaction is key in communication. Real innovations and a positive customer experience are the heart of successful communication. No fake products and services. The customer is king, their lives and needs are the inspiration.</p>
            </div>
        </div>
        <div class="sidebar-contact-feed">
            <h2>Contact</h2>
            <div class="contact-form">
                <form id="contactForm">
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <input type="text" name="name" id="name" class="form-control" placeholder="Your Name">
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <input type="email" name="email" id="email" class="form-control" placeholder="Your Email">
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <input type="text" name="phone_number" id="phone_number" class="form-control" placeholder="Your Phone">
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <input type="text" name="msg_subject" id="msg_subject" class="form-control" placeholder="Your Subject">
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <textarea name="message" class="form-control" id="message" cols="30" rows="6" placeholder="Your Message"></textarea>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="send-btn">
                                <button type="submit" class="send-btn-one">Send Message</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="sidebar-contact-area">
            <div class="contact-info">
                <div class="contact-info-content">
                    <h2>
                        <a href="tel:+0881306298615">+088 130 629 8615</a>
                        <span>OR</span>
                        <a href="mailto:hello@avrax.com">hello&#64;avrax.com</a>
                    </h2>
                    <ul class="social">
                        <li><a href="/home-two" target="_blank"><i class="flaticon-facebook"></i></a></li>
                        <li><a href="/home-two" target="_blank"><i class="flaticon-twitter"></i></a></li>
                        <li><a href="/home-two" target="_blank"><i class="flaticon-instagram"></i></a></li>
                        <li><a href="/home-two" target="_blank"><i class="flaticon-pinterest"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
        <span class="close-btn sidebar-modal-close-btn">
            <i class="flaticon-cancel"></i>
        </span>
    </div>
</div>
